import { render, staticRenderFns } from "./HomeFooter1.vue?vue&type=template&id=5b774184&scoped=true"
import script from "./HomeFooter1.vue?vue&type=script&lang=js"
export * from "./HomeFooter1.vue?vue&type=script&lang=js"
import style0 from "./HomeFooter1.vue?vue&type=style&index=0&id=5b774184&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b774184",
  null
  
)

export default component.exports